import { AnnotationBase, AnnotationPlugin, ToolStateBase } from '@st/document-viewer-kit/plugins/annotations'
import { calculatorTapePlugin } from './calculator-tape'
import { caretToolPlugin } from './caret'
import { commentToolPlugin } from './comment'
import { fieldPlugin } from './field'
import { rectToolPlugin } from './rectangle'
import { selectToolPlugin } from './select'
import { signOffsPlugin } from './sign-offs'
import { textToolPlugin } from './text'
import { stampPlugin } from './stamp'
import { crossReferencesPlugin } from './cross-references'
import { checkmarkPlugin } from './checkmark'

export const ST_DOC_VIEWER_PLUGINS = [
  caretToolPlugin(),
  calculatorTapePlugin(),
  commentToolPlugin(),
  rectToolPlugin(),
  selectToolPlugin(),
  fieldPlugin(),
  // Most-specific stamp variants first
  checkmarkPlugin(),
  signOffsPlugin(),
  crossReferencesPlugin(),
  stampPlugin(),
  textToolPlugin()
] as AnnotationPlugin<AnnotationBase, ToolStateBase>[]

export const ST_CONTRACT_VIEWER_PLUGINS = [
  selectToolPlugin(),
  fieldPlugin()
] as AnnotationPlugin<AnnotationBase, ToolStateBase>[]
